import React from 'react';
import { routes } from '#app/constants/routes';
import { LinkStyled, LinkStyledAsAnchor, LogoImg, Text } from './styles';

const DEFAULT_LOGO_SRC = require('./images/whiteswan-b.svg');
const DEFAULT_TITLE = 'белый лебедь';

/**
 * Логотип с торговой маркой (текст + картинка).
 * @param {string} [variant='default'] - 'default' | 'alternate' — размер (default = крупнее, alternate = мельче)
 * @param {string} [brand='whiteswan'] - 'whiteswan' | 'blackswan' — бренд (blackswan в alternate: font-size 13px и уменьшенная картинка)
 * @param {string} [theme='default'] - 'default' | 'light' — цвет текста (default = чёрный, light = белый для тёмного фона)
 * @param {string} [to] - URL ссылки для внутренней навигации (по умолчанию routes.ROOT)
 * @param {string} [href] - URL для внешней ссылки (если задан, используется <a> вместо <Link>)
 * @param {string} [src] - URL картинки логотипа (по умолчанию встроенная)
 * @param {string} [title] - Текст надписи над логотипом (по умолчанию "белый лебедь")
 * @param {boolean} [contentOnly] - если true, рендерит только контент (текст + картинка) без ссылки, чтобы обернуть в свою разметку
 */
function LogoWithTrademark({
  variant = 'default',
  brand = 'whiteswan',
  theme = 'default',
  to = routes.ROOT,
  href,
  src = DEFAULT_LOGO_SRC,
  title = DEFAULT_TITLE,
  contentOnly = false,
}) {
  const isSmall = variant === 'alternate';

  const content = (
    <>
      <Text $small={isSmall} $theme={theme} $brand={brand}>
        {title}
      </Text>
      <LogoImg src={src} alt={title} $small={isSmall} $brand={brand} />
    </>
  );

  if (contentOnly) {
    return content;
  }

  if (href) {
    return (
      <LinkStyledAsAnchor href={href} target="_blank" rel="noopener noreferrer">
        {content}
      </LinkStyledAsAnchor>
    );
  }

  return <LinkStyled to={to}>{content}</LinkStyled>;
}

export default LogoWithTrademark;
